/**
 * Checks if the element is still attached in DOM
 */
export default function isElementAttached(element: HTMLElement): boolean {
    if (element) {
        const ownerDoc = element.ownerDocument || document;
        return ownerDoc && ownerDoc.documentElement.contains(element);
    }

    return false;
}
